import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})

export class LoaderComponent implements OnInit
{
	@Input() type: string = 'position-fixed';
	@Input() app: 'arc' | 'hub' = 'arc';

	constructor()
	{

	}

	ngOnInit(): void
	{
		
	}

}
